import { call, put, takeLatest } from "redux-saga/effects";
import { lopApi } from "../../../api/category/lopApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import {
  IStuLopNamHocActionTypes,
  eStuLopNamHocActionIds,
} from "./../../action-types/category/IStuLopNamHocActions";

export function* lopNamHocSaga(): any {
  yield takeLatest(eStuLopNamHocActionIds.LOAD_START, loadWorker);
}

function* loadWorker(action: IStuLopNamHocActionTypes): any {
  //const res: IBaseRespone = yield call(lopApi.SelectByNamHoc, action.payload as string);
  const res: IBaseRespone = yield call(lopApi.SelectAll);
  if (res.is_success) {
    yield put(rootActions.category.lopNamHoc.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.lopNamHoc.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}
